<template>
  <div class="section-card">

    <h2 class="h5 section-title" :class="{ collapsed: !hideChevron }">

      <div
        class="d-flex align-items-center flex-grow-1"
        v-b-toggle="collapseId"
        role="button"
        :aria-controls="collapseId"
      >
        <feather-icon :icon="icon" size="20" class="section-icon mr-1"/>
        <span>{{ title }}</span>
      </div>

      <div class="d-flex align-items-center ml-auto">
        <!-- <b-dropdown
          v-if="capturable"
          size="sm"
          variant="outline-info"
          right
          no-caret
          boundary="viewport"
          menu-class="shadow"
          class="mr-1 section-capture"
          toggle-class="px-1 py-0"
        >
          <template #button-content>
            <feather-icon icon="CameraIcon" size="14" />
          </template>

          <b-dropdown-item @click="downloadImage('png')">
            <feather-icon icon="DownloadIcon" size="14" class="mr-1" />
            Descargar PNG
          </b-dropdown-item>
          <b-dropdown-item @click="downloadImage('jpg')">
            <feather-icon icon="DownloadIcon" size="14" class="mr-1" />
            Descargar JPG
          </b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-item @click="copyImage">
            <feather-icon icon="CopyIcon" size="14" class="mr-1" />
            Copiar al portapapeles
          </b-dropdown-item>
        </b-dropdown> -->

        <b-button
          v-if="capturable"
          size="sm"
          variant="outline-info"
          class="mr-1 section-capture px-1 py-0"
          @click.stop="downloadImage('jpg')"
        >
          <feather-icon icon="CameraIcon" size="14" />
        </b-button>

        <feather-icon
          v-if="!hideChevron"
          icon="ChevronDownIcon"
          size="16"
          class="chevron"
          v-b-toggle="collapseId"
          role="button"
        />
      </div>
    </h2>

    <b-collapse
      :id="collapseId"
      :visible="defaultOpen"
      @hidden="onHidden"
      @shown="onShown"
      style="padding-top: 10px;"
    >
      <div ref="body">
        <slot />
      </div>
    </b-collapse>
  </div>
</template>

<script>
import html2canvas from "html2canvas";

export default {
  name: "SectionCollapse",
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    uniqueId: {
      type: String,
      required: true,
    },
    sectionKey: {
      type: String,
      required: true,
    },
    defaultOpen: {
      type: Boolean,
      default: false,
    },
    hideChevron: {
      type: Boolean,
      default: false,
    },
    capturable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      collapseVisible: this.defaultOpen,
    };
  },
  computed: {
    collapseId() {
      return `collapse${this.sectionKey}-${this.uniqueId}`;
    },
    fileSlug() {
      return (this.title || this.sectionKey)
        .toString()
        .trim()
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^\w-]/g, "");
    },
  },
  methods: {
  onShown() {
    this.collapseVisible = true;
    this.$emit("collapse-update");
  },
  onHidden() {
    this.collapseVisible = false;
    this.$emit("collapse-update");
  },

  async ensureCapture() {
    if (!this.collapseVisible) {
      this.$root.$emit("bv::toggle::collapse", this.collapseId);
    }
    const el = await this.waitForBody();
    if (!el) throw new Error("No se encontró el cuerpo de la sección");

    await new Promise((r) => setTimeout(r, 350));

    const isDark = document.body.classList.contains("dark-layout");
    return html2canvas(el, {
      useCORS: true,
      scale: 2,
      backgroundColor: isDark ? "#283046" : "#ffffff",
    });
  },

  waitForBody(retries = 20) {
    return new Promise((resolve) => {
      const check = () => {
        if (this.$refs.body) return resolve(this.$refs.body);
        if (retries-- <= 0) return resolve(null);
        setTimeout(check, 50);
      };
      check();
    });
  },

  async downloadImage(format = "png") {
    try {
      const canvas = await this.ensureCapture();
      const mime = format === "jpg" ? "image/jpeg" : "image/png";
      const link = document.createElement("a");
      link.download = `${this.fileSlug}.${format}`;
      link.href = canvas.toDataURL(mime, 0.95);
      link.click();
    } catch (e) {
      console.error("Error al descargar la imagen:", e);
    }
  },

  async copyImage() {
    try {
      const canvas = await this.ensureCapture();
      const blob = await new Promise((resolve) =>
        canvas.toBlob(resolve, "image/png")
      );
      await navigator.clipboard.write([
        new ClipboardItem({ "image/png": blob }),
      ]);
    } catch (e) {
      console.error("Error al copiar la imagen:", e);
    }
  },
},

};
</script>